module.exports = __webpack_public_path__ + "static/img/cePath3.5a5c47b1.gif";